<template>
  <WidgetLayout
    :class-name="selectedAlertType === 'Full' ? 'rounded-sm overflow-hidden mb-4 !p-0' : 'mb-4 !p-0'"
    :background-color="fullBackgroundColor">
    <div class="alert-widget-component">
      <template v-if="selectedAlertType === 'Round'">
        <AlertWidgetRound
          :alert-text="alertText"
          :background-color="selectedBackgroundColor"
          :text-color="selectedTextColor"
          :text-align="selectedTextAlign" />
      </template>
      <template v-else-if="selectedAlertType === 'Full'">
        <AlertWidgetFull
          :alert-text="alertText"
          :background-color="selectedBackgroundColor"
          :text-color="selectedTextColor"
          :text-align="selectedTextAlign" />
      </template>
    </div>
  </WidgetLayout>
</template>

<script lang="ts" setup>
import WidgetLayout from './../WidgetLayout.vue'
import type { TranslatableString } from '~/types/widgets/widgetTypes'
import AlertWidgetRound from '~/components/Widgets/AlertWidget/AlertWidgetRound.vue'
import AlertWidgetFull from '~/components/Widgets/AlertWidget/AlertWidgetFull.vue'

const { backgroundColor, textColor, textAlign, alertText, alertType } = defineProps<{
  backgroundColor?: string
  textColor?: string
  textAlign?: string | string[]
  alertText?: TranslatableString
  alertType?: string | string[]
}>()

const fullBackgroundColor = computed(() => {
  if (selectedAlertType.value === 'Full') {
    return selectedBackgroundColor.value
  }

  return 'transparent'
})

const selectedBackgroundColor = computed(() => {
  return backgroundColor || '#C566FF'
})

const selectedTextColor = computed(() => {
  return textColor || '#FFFFFF'
})

const selectedAlertType = computed(() => {
  return Array.isArray(alertType) ? alertType[0] : alertType
})

const selectedTextAlign = computed(() => {
  return Array.isArray(textAlign) ? textAlign[0] : textAlign
})
</script>

<style lang="postcss" scoped>
.alert-widget-component {
  @apply flex w-full;
}
</style>
